import React from 'react';
import { useGetOGPUserInfo } from 'ogp/hooks/queryHooks/users/use-get-ogp-user-info';
import { hasOgpAccessOrHqCompanyAdmin, PolicyGroupAndRoles } from 'shared/utils/policy-controller';
import { useIsHqImpersonation, useSiteDetection } from 'shared/hooks';

type AuthenticatedElementProps =
  | (PolicyGroupAndRoles & { children: React.ReactElement; hqImpersonationOnly?: false })
  | { hqImpersonationOnly: true; children: React.ReactElement };

const AuthenticatedElement = (props: AuthenticatedElementProps) => {
  const { children } = props;
  const { data: user } = useGetOGPUserInfo();
  const isHqImpersonation = useIsHqImpersonation();
  const { isHQ: isHqSite } = useSiteDetection();

  if (props.hqImpersonationOnly) {
    if (isHqImpersonation || isHqSite) {
      return children;
    }
    return null;
  }

  const { roles, policyGroup } = props;

  if (isHqImpersonation || isHqSite) {
    return children;
  }

  if (!user) {
    return null;
  }

  if (!hasOgpAccessOrHqCompanyAdmin(policyGroup, user.userInfo, roles)) {
    return null;
  }

  return children;
};

export { AuthenticatedElement };
